import { Component, Inject, Injector, OnDestroy, PLATFORM_ID } from '@angular/core';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { LoginComponent } from '../login/login.component';
import { AbstractControl, FormGroup, ReactiveFormsModule, ValidatorFn, Validators } from '@angular/forms';
import { BaseClass } from '../../../shared/baseClass/baseClass';
import { Subject, takeUntil } from 'rxjs';
import { REGEX } from '../../../core/constants/regex.const';
import { MustMatch, passwordValidatorHelper } from '../../../core/helpers/validators.helpers';
import { passwordFormErrors } from '../../../core/constants/commonErrors.const';
import { AuthService } from '../../../services/auth.service';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'xplora-website-reset-password',
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatDialogModule,
    TranslateModule,
    ReactiveFormsModule
  ],
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss'
})
export class ResetPasswordComponent extends BaseClass implements OnDestroy {

  protected submitted = false;
  protected hide1 = true;
  protected hide2 = true;
  formErrors = passwordFormErrors;
  private destroy: Subject<boolean> = new Subject<boolean>();
  protected resetPasswordFormGroup: FormGroup;

  constructor(
    injector: Injector,
    public dialog: MatDialog,
    private dialogRef: MatDialogRef<ResetPasswordComponent>,
    private _authService: AuthService,
    @Inject(PLATFORM_ID) private platformId: object
  ) {
    super(injector);
    this.resetPasswordFormGroup = this.formBuilder.group(
      {
        newPassword: [
          '',
          [Validators.required, Validators.pattern(REGEX.PASSWORD_PATTERN)]
        ],
        confirmPassword: ['', [Validators.required]]
      },
      { validators: MustMatch('newPassword', 'confirmPassword') }
    );
    this.onControlValueChange();
  }

  onControlValueChange(): void {
    const passwordControl = this.resetPasswordFormGroup.get('newPassword');

    if (passwordControl) {
      passwordControl.setValidators([
        Validators.required,
        this.passwordValidator()
      ]);
    }
  }

  passwordValidator = (): ValidatorFn => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (control: AbstractControl): { [key: string]: any } | null => {
      const fName = null;
      const userEmail = 'ownrsclub@yopmail.com';
  
      return passwordValidatorHelper(control, {
        firstName: fName,
        userEmail
      });
    };
  };

  onSubmit(): void {
    this.submitted = true;
    if (this.resetPasswordFormGroup.valid) {

      this.spinnerService.addToLoader('resetPassword');
      this._authService.resetPassword(this.resetPasswordFormGroup.value)
        .pipe(takeUntil(this.destroy))
        .subscribe({
          next: () => {
            this.spinnerService.removeFromLoader('resetPassword');
            this.toasterService.successToastr(
              this.translateService.instant('resetPassSuccess')
            );
            if (isPlatformBrowser(this.platformId)) {
              localStorage.clear();
            } 
            this.openLoginModal();
            this.dialogRef.close();
          },
          error: () => {
            this.spinnerService.removeFromLoader('resetPassword');
          }
        });
    }
  }

  openLoginModal(): void {
    this.dialog.open(LoginComponent, {
      panelClass: ['modal', 'auth_modal']
    });
  }

  ngOnDestroy(): void {
    this.destroy.complete();
    this.destroy.unsubscribe();
  }
}
